module.exports = __webpack_public_path__ + "img/logo-mbe-horizontal.3356cf5d.svg";